import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CreateHeroImage from "./CreateHeroImage";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import HeroSectiontableRow from "./HeroSectiontableRow";
import { THeroSection } from "src/Types/module/heroSection/heroSectiontype";
import axios from "axios";
import { TOKEN_KEY, url } from "src/Helpers/utils/Constant";

type Props = {};

const HeroSection = (props: Props) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [loading, setLoading] = useState(false);
  const [heroImages, setHeroImages] = useState<THeroSection[] | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const token = localStorage.getItem(TOKEN_KEY);
  // Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const uri = `${url}/api/v1/admin/website-slider`;
        const { data } = await axios.get(uri, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        if (data.success) {
          setHeroImages(data.data);

          setLoading(false);
        } else {
          setLoading(false);
        }
        setLoading;
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [refreshTrigger]);

  return (
    <Container maxWidth="xl">
      <Card>
        <CardContent>
          <CardHeader
            action={
              <Box>
                {" "}
                <Button
                  onClick={() => handleOpen()}
                  variant="contained"
                  sx={{ ml: 2 }}
                >
                  Create Hero Image
                </Button>
              </Box>
            }
            title="Hero Image List"
          />
          <Divider />
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SL</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Alt Text</TableCell>
                  <TableCell>Order</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              {loading ? (
                <TableLoader />
              ) : heroImages?.length ? (
                <TableBody>
                  {heroImages.map((heroimage: THeroSection, i) => {
                    return (
                      <HeroSectiontableRow
                        key={i}
                        index={i}
                        heroimage={heroimage}
                        heroImages={heroImages}
                        setHeroImages={setHeroImages}
                        setRefreshTrigger={setRefreshTrigger}
                      />
                    );
                  })}
                </TableBody>
              ) : (
                <TableNotFound />
              )}
            </Table>
          </TableContainer>
        </CardContent>
        {/* create image modal */}
        <Dialog
          fullScreen={fullScreen}
          open={open}
          maxWidth="md"
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ mb: 2 }}>Create hero image</Typography>
              <Divider />
            </Box>
            <CreateHeroImage
              handleClose={handleClose}
              setRefreshTrigger={setRefreshTrigger}
            />
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Card>
    </Container>
  );
};

export default HeroSection;
